import { Component, OnInit, ViewChild } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { Cliente } from '../model/cliente.model';
import { ClientesService } from '../service/clientes.service';
import { Router } from '@angular/router';
import { VerificarPermissoes } from '../model/verificarPermissoes.model';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { ProdutosService } from '../service/produtos.service';
import { Produtos } from '../model/produtos.model';
import { AgviewsConnectService } from '../service/agviews-connect.service';

@Component({
  selector: 'app-agviews-connect',
  templateUrl: './agviews-connect.component.html',
  styleUrls: ['./agviews-connect.component.css']
})
export class AgviewsConnectComponent implements OnInit {

  clientes!: Cliente[];
  produtos!: Produtos[];
  clienteId: string = '';
  carregandoAgviewsConnect: boolean = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  value: number = 50;
  semAgviewsConnect: boolean = false;
  produtoId: string = '';
  public dataSource: MatTableDataSource<any> = new MatTableDataSource();
  public columnsToDisplay: any[] = [
    'sr_id',
    'vc_imei',
    'vc_produto',
    'ts_criado_em',
    'controls'
  ];

  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;

  constructor(
    private serviceAgviewsConnect: AgviewsConnectService,
    private serviceCliente: ClientesService,
    private serviceProduto: ProdutosService,
    private router: Router,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.listarCliente();
    this.listarProduto();
  }

  listarCliente() {
    this.serviceCliente.listarServiceClientes().subscribe((resp: any) => {
      this.clientes = resp
      this.clienteId = localStorage.getItem('cliente')! != 'null' ? localStorage.getItem('cliente')! : '';

      this.listarAgviewsConnectPaginate();
    }, (error: any) => {
      if (error == "401") {
        localStorage.removeItem('token')
        this.router.navigate(['/'])
      }
    })
  }

  listarAgviewsConnectPaginate() {
    this.carregandoAgviewsConnect = true;
    this.semAgviewsConnect = false;

    let params = {
      ...(this.clienteId && { 'cliente': this.clienteId }),
      ...(this.produtoId && { 'produto': this.produtoId }),
    };

    this.serviceAgviewsConnect.listarAgviewsConnect(params).subscribe((resp: any) => {
      if (resp == null) {
        this.semAgviewsConnect = true;
      }
      resp.forEach((agviewConnect: any) => {
        agviewConnect.vc_produto = agviewConnect.produto ? agviewConnect.produto.vc_nome : 'Sem produto vinculado';
      });
      this.dataSource.data = resp;
      this.dataSource.paginator = this.paginator;
      this.carregandoAgviewsConnect = false
    }, (error: any) => {
      this.semAgviewsConnect = true;
      if (error == "401") {
        localStorage.removeItem('token')
        this.router.navigate(['/'])
      }
    })
  }

  listarProduto() {
    this.serviceProduto.listarService().subscribe((resp: any) => {
      this.produtos = resp
    },(error: any) => {
        if (error == "401") {
          localStorage.removeItem('token')
          this.router.navigate(['/'])
        }
      })
  }

  public verificarPermissao(permissoesFuncionalidades: string[]): boolean {
    const permissaoUsuario = localStorage.getItem('permissoes');
    return VerificarPermissoes.temPermissao(permissoesFuncionalidades, permissaoUsuario)
  }

  pesquisarAgviewsConnect(event: Event): void {
    const pesquisa = (event.target as HTMLInputElement).value;
    this.dataSource.filter = pesquisa;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}